import localeAntd from 'antd/es/locale/fr_FR'

const messages = {
  'topBar.issuesHistory': 'Histoire des problèmes',
  'topBar.projectManagement': 'Gestion de projet',
  'topBar.typeToSearch': 'Chercher...',
  'topBar.findPages': 'Trouver des pages...',
  'topBar.actions': 'Actes',
  'topBar.status': 'Statut',
  'topBar.profileMenu.hello': 'Bonjour',
  'topBar.profileMenu.billingPlan': 'Plan de facturation',
  'topBar.profileMenu.role': 'Rôle',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Téléphone',
  'topBar.profileMenu.editProfile': 'Editer le profil',
  'topBar.profileMenu.logout': 'Déconnexion',
  'topBar.mobidoc.description': 'Votre assistant personnel',

  // FILE DETAILS
  'fileDetails.download_btn': 'Télécharger',
  'fileDetails.delete_btn': 'Effacer',
  'fileDetails.edit_btn': 'Editer',
  'fileDetails.save_btn': 'Sauver',
  'fileDetails.previous_btn': 'Précédent',
  'fileDetails.next_btn': 'Suivant',
  'fileDetails.page_of': 'sur ',

  'fileDetails.category_num': 'There is {categories} num of categories',
  'fileDetails.category_title': 'CATÉGORIES :',
  'fileDetails.category_add': 'Ajouter Catégorie',
  'fileDetails.category_number': `{categories, plural, 
                                      =0 {Il n'y a aucunes catégories} 
                                      one {Il y a # catégorie} 
                                      other {Il y a # catégories}}`,

  'fileDetails.tag_title': 'LISTE DES TAGS :',
  'fileDetails.tag_add': 'Ajouter Tag',
  'fileDetails.tag_show_more': 'Voir plus...',
  'fileDetails.tag_hide': 'Cacher...',

  // HOME
  'home.welcome': 'Bienvenue sur ',
  'home.presentation': 'Votre seul et unique assistant administratif',
  'home.presentation.value':
    'Scanner, stocker et automatiser toutes vos taches administratives en économisant du papier',
  'home.credentials.test': "Accès pour tester l'application - ",
  'home.sign_up': "S'enregistrer",
  'home.sign_in.text': 'Connectez-vous à votre compte',
  'home.sign_in': 'Connexion',
  'home.email': 'Adresse email',
  'home.password': 'Mot de passe',
  'home.password.forgot': 'Mot de passe oublié ?',
  'home.sign_up.text': 'Pas encore de compte ?',

  // ON BOARDING
  'onBoarding.steps.title.mail': 'Confirmation',
  'onBoarding.steps.title.plan': 'Abonnement',
  'onBoarding.steps.title.payment': 'Payement',
  'onBoarding.steps.title.done': 'Finalisation',
  'onBoarding.button.next': 'Suivant',
  'onBoarding.button.previous': 'Précédent',
  'onBoarding.button.changeAbo': "Changer d'abonnement",
  'onBoarding.button.firstStep': 'Continuer',
  'onBoarding.button.done': 'Aller au dashboard',
  // MAIL STEP
  'onBoarding.mail.verification.thankYou': 'Merci pour votre inscription',
  'onBoarding.mail.verification.guide':
    "Nous allons vous guider à travers le processus d'enregistrement. Ces étapes vous aiderons à valider votre compte ainsi qu'a choisir un abonnement selon vos besoins",
  'onBoarding.mail.verification.resendEmail': 'Renvoyer',
  'onBoarding.mail.verification.validEmail': 'Adresse email validée',
  'onBoarding.mail.verification.invalidEmail.message': 'Merci de confirmer votre adresse email',
  'onBoarding.mail.verification.invalidEmail.description': 'Vérifier votre boîte mail',

  // PLAN SELECTION
  'onBoarding.subscription.plan.pricing_table': 'Tarifs',
  'onBoarding.subscription.plan.select': 'Séléctionner',
  'onBoarding.subscription.plan.month': 'mois',

  'onBoarding.subscription.freePlan.month': 'gratuit',
  'onBoarding.subscription.freePlan.trial': "90 jours d'essai",
  'onBoarding.subscription.freePlan.title': 'Découverte',
  'onBoarding.subscription.freePlan.options.trial': "90 jours d'essai",
  'onBoarding.subscription.freePlan.options.1': 'Essai gratuit',
  'onBoarding.subscription.freePlan.options.2': 'Stockage illimité',
  'onBoarding.subscription.freePlan.options.3': 'Données stockées en suisse',

  'onBoarding.subscription.monthlyPlan.title': 'Mensuel',
  'onBoarding.subscription.monthlyPlan.options.trial': '90 jours gratuit inclus',
  'onBoarding.subscription.monthlyPlan.options.1': 'Données stockées en suisse',
  'onBoarding.subscription.monthlyPlan.options.2': 'Stockage illimité',
  'onBoarding.subscription.monthlyPlan.options.3': ' ',

  'onBoarding.subscription.yearlyPlan.title': 'Annuel',
  'onBoarding.subscription.yearlyPlan.options.trial': 'Économisez 2 mois',
  'onBoarding.subscription.yearlyPlan.options.1': '90 jours gratuit inclus',
  'onBoarding.subscription.yearlyPlan.options.2': 'Stockage illimité',
  'onBoarding.subscription.yearlyPlan.options.3': 'Données stockées en suisse',

  // On Boarding Payment Step
  'onBoarding.payment.form.title': 'Formulaire de payement',
  'onBoarding.payment.form.error.msg': 'Vérifier le formulaire',
  'onBoarding.payment.form.error.desc': 'des erreurs ont été détectées',
  'onBoarding.payment.form.label.fullname': 'Nom complet',
  'onBoarding.payment.form.error.fullname': "Merci d'entrer votre nom complet",
  'onBoarding.payment.form.label.street': 'Rue',
  'onBoarding.payment.form.error.street': "Merci d'entrer votre adresse",
  'onBoarding.payment.form.label.city': 'Ville',
  'onBoarding.payment.form.error.city': 'Entrer votre ville',
  'onBoarding.payment.form.label.state': 'Etat / Canton',
  'onBoarding.payment.form.error.state': "Merci d'entrer un état/canton valide",
  'onBoarding.payment.form.label.postal': 'Code postal',
  'onBoarding.payment.form.error.postal': 'Entrer un code postal correct',
  'onBoarding.payment.form.label.card': 'Carte',
  // Stripe error code
  'onBoarding.payment.stripe.error.incomplete_number': 'Votre numéro de carte est incomplet.',
  'onBoarding.payment.stripe.error.incorrect_number': 'Le numéro de carte est incorrecte.',
  'onBoarding.payment.stripe.error.invalid_number':
    "Le numéro de carte n'est pas un numéro valide.",
  'onBoarding.payment.stripe.error.error.invalid_expiry_month':
    "Le mois d'expiration de la carte est invalide.",
  'onBoarding.payment.stripe.error.invalid_expiry_year':
    "L'année d'expiration de la carte est invalide.",
  'onBoarding.payment.stripe.error.invalid_cvc': 'Le code de sécurité de la carte est invalide.',
  'onBoarding.payment.stripe.error.expired_card': 'La validité de la carte est dépassée.',
  'onBoarding.payment.stripe.error.incorrect_cvc': 'Le code de sécurité de la carte est incorrect.',
  'onBoarding.payment.stripe.error.incorrect_zip':
    "La code postal fourni n'a pas passé la validation.",
  'onBoarding.payment.stripe.error.card_declined': 'La carte a été refusée.',
  'onBoarding.payment.stripe.error.missing': "Il n'y a pas de carte pour le client actuel.",
  'onBoarding.payment.stripe.error.processing_error':
    'Une erreur est apparue durant le processus de validation.',
  'onBoarding.payment.stripe.error.rate_limit': 'Erreur suite a un trop grand nombre de requête',
}

export default {
  locale: 'fr-FR',
  localeAntd,
  messages,
}
